package com.essntl.uikit.components.chat.conversation

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.theme.esColorScheme

enum class ConversationType {
    Sms, Whatsapp, Mail, WhatsappCall;

    val icon
        get() = when (this) {
            Sms -> EsIcons.Sms
            Whatsapp -> EsIcons.Whatsapp
            Mail -> EsIcons.Mail
            WhatsappCall -> EsIcons.Whatsapp // Use Whatsapp icon as placeholder
        }

    val iconColor
        @Composable
        get() = when (this) {
            Sms, Mail -> MaterialTheme.esColorScheme.iconSecondary
            Whatsapp, WhatsappCall -> MaterialTheme.esColorScheme.iconSuccess
        }

    val value
        get() = when (this) {
            Sms -> "SMS"
            Whatsapp -> "Whatsapp"
            Mail -> "Mail"
            WhatsappCall -> "WhatsappCall"
        }
}